import React, { Component } from 'react';
import './index.scss';
import parapic1 from '../../../../../assets/catalog/electricmeter/para/para-1.png'
import parapic2 from '../../../../../assets/catalog/electricmeter/para/para-2.png'




class ElectricPara extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  
  componentDidMount(){
    document.title='电表参数'
  }

  render() {
    return (
      <div className="imageBlock">
          <img src={parapic1}/>
          <img src={parapic2}/>
      </div>
    );
  }

}

export default ElectricPara;
